import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import DavidSilberman from '../../assets/images/David_Silberman2008.jpg';
import JohnDoryk from '../../assets/images/John_Doryk.jpg';
//import styles from './Music.css';

function Music() {
  return (
<div className="mainContent">
<h1>Music</h1>
            <p>We have arrangements with various music supervisors, producers, and composers who will be able to score and write original music for your film. Please contact us for details. Some of these include:
            </p>
      
      <Container fluid>
          <Row>
              <Col xs={{ span: 12 }}sm={{ span: 6}} className=" pictureBlock">
      <img src={DavidSilberman}  alt="David Silberman" width="144" height="216" /><br />
      <span className="caption">David Silberman<br /><a href="http://www.soundsonfilm.com" target="_blank" rel="noopener noreferrer">www.soundsonfilm.com</a></span>
      </Col>

      <Col xs={{ span: 12 }}sm={{ span: 6}} className="pictureBlock">
      <img src={JohnDoryk}  alt="John Dortk" width="144" height="216" /><br />
      <span className="caption">John Doryk<br /><a href="http://www.johndoryk.com/" target="_blank" rel="noopener noreferrer">www.johndoryk.com</a></span>
      </Col>
    </Row>
    </Container>
</div>

  )
  }

export default Music;
